module.exports = __webpack_public_path__ + "img/LOGO-ERTIGA-DARKBG.bee83706.svg";